{
  "name": "@fido/portal",
  "private": true,
  "version": "2.8.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "cross-env NODE_OPTIONS=--max-old-space-size=6144 vite build",
    "build:prod": "pnpm run build && pnpm run sentry:sourcemaps",
    "download-translations": "node src/scripts/download.cjs",
    "i18n:normalize": "node ../../scripts/lokalise/i18n-normalize.mjs",
    "i18n:sort": "node ../../scripts/lokalise/i18n-sort-locale.mjs",
    "lokalise:push:en": "node ../../scripts/lokalise/lokalise-upload-en.mjs",
    "lokalise:pull": "node ../../scripts/lokalise/lokalise-pull-translations.mjs",
    "lokalise:sync": "pnpm run i18n:sort -- en && pnpm run lokalise:push:en && pnpm run lokalise:pull && pnpm run i18n:normalize",
    "lint": "cross-env NODE_OPTIONS=\"--max-old-space-size=6144\" eslint . --cache --cache-location .eslintcache",
    "fix": "cross-env NODE_OPTIONS=\"--max-old-space-size=6144\" eslint . --cache --cache-location .eslintcache --fix",
    "healthcheck": "cross-env NODE_OPTIONS=\"--max-old-space-size=8192\" tsc -p tsconfig.app.json --noEmit --extendedDiagnostics --listFiles | grep -Ev \"/src/|node_modules\"",
    "format": "prettier . --write",
    "preview": "vite preview",
    "test:unit": "cross-env VITE_NODE_ENV=testing vitest --project unit",
    "test:unit:ci": "cross-env VITE_NODE_ENV=testing CI=true vitest --project unit --silent=true",
    "test:unit:ci:verbose": "cross-env VITE_NODE_ENV=testing CI=true vitest --project unit --silent=false",
    "test:browser": "cross-env VITE_NODE_ENV=testing vitest --project browser",
    "test:browser:ci": "cross-env VITE_NODE_ENV=testing CI=true vitest --project browser --silent=true --passWithNoTests",
    "test:browser:ci:verbose": "cross-env VITE_NODE_ENV=testing CI=true vitest --project browser --silent=false --passWithNoTests",
    "test": "pnpm run test:ci --",
    "test:ci": "concurrently -P -n unit,browser --kill-others-on-fail --success=all \"pnpm:test:unit:ci {@}\" \"pnpm:test:browser:ci {@}\" --",
    "test:ci:verbose": "concurrently -P -n unit,browser --kill-others-on-fail --success=all 'pnpm:test:unit:ci:verbose {@}' 'pnpm:test:browser:ci:verbose {@}' --",
    "test:coverage": "vitest --coverage --watchAll",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org fido-tech --project fido-portal ./build && sentry-cli sourcemaps upload --org fido-tech --project fido-portal ./build",
    "release:portal:check": "node src/scripts/release-prereqs.cjs",
    "typecheck": "tsc -b tsconfig.json --noEmit"
  },
  "dependencies": {
    "@azure/msal-browser": "^5.18.0",
    "@azure/msal-react": "^5.5.5",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@fontsource-variable/mulish": "^5.3.0",
    "@hookform/resolvers": "5.7.1",
    "@mapbox/mapbox-gl-geocoder": "^5.1.2",
    "@reduxjs/toolkit": "^2.12.0",
    "@sentry/cli": "^3.6.2",
    "@sentry/react": "^10.69.0",
    "@statsig/react-bindings": "^3.33.3",
    "@statsig/session-replay": "3.33.3",
    "@statsig/web-analytics": "3.33.3",
    "@tanstack/react-table": "^8.21.3",
    "adm-zip": "^0.6.0",
    "axios": "^1.19.0",
    "betterknown": "^1.2.0",
    "clsx": "^2.1.1",
    "color": "^5.0.3",
    "d3-dsv": "^3.0.1",
    "date-fns": "^4.4.0",
    "dotenv": "^17.4.2",
    "eslint-config-prettier": "^10.1.8",
    "formik": "^2.4.9",
    "fp-ts": "^2.16.11",
    "framer-motion": "^13.0.0",
    "geojson": "^0.5.0",
    "got": "^15.1.0",
    "i18n-iso-countries": "^7.14.0",
    "i18next": "^26.3.6",
    "io-ts": "^2.2.22",
    "lodash.debounce": "^4.0.8",
    "lodash.throttle": "^4.1.1",
    "mapbox-gl": "^3.28.0",
    "moment": "^2.30.1",
    "nuqs": "^2.9.5",
    "plotly.js": "^3.7.0",
    "react": "^19.2.8",
    "react-date-range": "^2.0.1",
    "react-datepicker": "^9.1.0",
    "react-dom": "^19.2.8",
    "react-dropzone": "^20.0.0",
    "react-hook-form": "^7.84.0",
    "react-i18next": "^17.0.11",
    "react-icons": "^5.7.0",
    "react-image-gallery": "^2.1.2",
    "react-paginate": "^8.3.0",
    "react-phone-number-input": "^3.4.17",
    "react-photo-view": "^1.2.7",
    "react-plotly.js": "^4.1.0",
    "react-redux": "^9.3.0",
    "react-router": "^8.3.0",
    "react-select": "^5.10.2",
    "react-sortable-hoc": "^2.0.0",
    "react-spring": "^10.0.4",
    "react-toastify": "^11.1.0",
    "react-tooltip": "^6.0.8",
    "react-use-websocket": "^4.13.0",
    "recharts": "^3.5.0",
    "redux-logger": "^3.0.6",
    "redux-persist": "^6.0.0",
    "reselect": "^5.2.0",
    "styled-components": "^5.3.5",
    "uuid": "^14.0.1",
    "yup": "^1.7.1",
    "yup-phone-lite": "^2.0.1",
    "zod": "^4.4.3"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@fido/config-ts": "workspace:*",
    "@fido/ui-lib": "workspace:*",
    "@lokalise/node-api": "^16.3.0",
    "@tailwindcss/vite": "^4.3.3",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^7.0.0",
    "@testing-library/react": "^16.3.2",
    "@testing-library/react-hooks": "^8.0.1",
    "@testing-library/user-event": "^14.6.3",
    "@types/d3-dsv": "^3.0.7",
    "@types/eslint__js": "^9.14.0",
    "@types/geojson": "^7946.0.16",
    "@types/jsdom": "^28.0.3",
    "@types/lodash.debounce": "^4.0.9",
    "@types/lodash.throttle": "^4.1.9",
    "@types/mapbox__mapbox-gl-geocoder": "^5.1.1",
    "@types/react": "^19.2.18",
    "@types/react-date-range": "^1.4.10",
    "@types/react-dom": "^19.2.4",
    "@types/redux-logger": "^3.0.13",
    "@typescript-eslint/eslint-plugin": "8.66.0",
    "@typescript-eslint/parser": "8.66.0",
    "@vitejs/plugin-react": "^6.0.5",
    "@vitest/browser-playwright": "^4.1.10",
    "eslint": "^10.8.0",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-refresh": "^0.5.3",
    "globals": "^17.9.0",
    "husky": "^9.1.7",
    "jsdom": "^28.0.0",
    "msw": "^2.15.0",
    "prettier": "^3.9.6",
    "rollup-plugin-visualizer": "^7.0.1",
    "tailwindcss": "^4.3.3",
    "tw-animate-css": "^1.4.0",
    "typescript-eslint": "8.66.0",
    "vite": "~8.2.1",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^4.1.10",
    "vitest-browser-react": "^2.2.0",
    "vitest-canvas-mock": "^1.1.4",
    "vitest-webgl-canvas-mock": "^1.1.0"
  }
}
